import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface SpinnerProps {
  size?: number;
  className?: string;
}

export const Spinner = ({ size = 24, className }: SpinnerProps) => {
  return (
    <Loader2
      size={size}
      className={cn("animate-spin", className)}
      aria-label="Carregando"
    />
  );
};
